//Note: this file is compared to one dynamically generated from
//ExternalWebsites\FrontEndApi.Tests\ClientSideScriptCodeGeneration\ModernFrontEndApiJs.tt
//You should update the T4 file and regenerate this one using the test in
//ClientSideScriptCodeGenerationTests

var FrontEndApi = (function () {
    'use strict';

    var FrontEndApi = {};

    function rejectRequest(reason, response, handled, responseObject) {
        var error = new Error(reason);
        error.handled = handled;
        error.response = response;
        if(responseObject)
            error.responseObject = responseObject;
        throw error;
    }

    function submitRequest(body, apiPartUrl, contentType) {
        return fetch('/FrontEndApi/' + apiPartUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': contentType
            },
            body: body
        }).then(function(response) {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else if (response.status === 401) {
                console.log("Current Cookie State: " + document.cookie);
                window.location.href = '/App/Auths/LogIn?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                return rejectRequest('HTTP status ' + response.status, response, true);
            }
            else
            {
                //TODO: Replace this with 'throw response.error();' when supported (SEE https://developer.mozilla.org/en-US/docs/Web/API/Response/error)
                try {
                    return response
                    .clone()
                    .json()
                    .then(function(responseJson) {
                        console.log("Current Cookie State: ");
                        console.log(document.cookie);
                        return rejectRequest('HTTP status ' + response.status + ': ' + responseJson.reason, response, false, responseJson);
                    }, function(jsonError) {
                        return rejectRequest('HTTP status ' + response.status, response);
                    });
                }
                catch(fetchError){
                    return rejectRequest('HTTP status ' + response.status, response);
                }
            }
        });
    }

    function decorateRequestWithTrackingAndSubmit(messageOnRequestSubmitted, messageOnRequestCompleted, details, submitRequestCallback) {
        if (window.location.hostname === 'localhost' ||  window.location.hostname === 'syst.ecargo.net') {
            var correlationId = crypto.randomUUID();
            console.log(messageOnRequestSubmitted + ": [" + correlationId + "] " + details);

            return submitRequestCallback()
                .then(function(successResponse) {
                    handleCompletionOfSubmittedRequest(messageOnRequestCompleted, correlationId, successResponse);
                    return successResponse;
                })
                .catch(function(error) {
                    handleCompletionOfSubmittedRequest(messageOnRequestCompleted, correlationId, error.response);
                    throw error;
                });
        } else {
            return submitRequestCallback();
        }
    }

    function handleCompletionOfSubmittedRequest(messageOnRequestCompleted, correlationId, response) {
        console.log(messageOnRequestCompleted + ": [" + correlationId + "] " + response.status);
    }

    FrontEndApi.submit = function submitRequestToFrontEndApi(arrayOfCommandsAndQueries) {
        var body = JSON.stringify({ sequence: arrayOfCommandsAndQueries });
        var distinctListOfQueries = arrayOfCommandsAndQueries.map(function(c) { return c.name }).filter(function(value, index, self) { return self.indexOf(value) === index }).join();

        return decorateRequestWithTrackingAndSubmit("eCargo command or query submitted", "eCargo command or query completed", body, function() {
            return submitRequest(body, 'CommandsAndQueries?q=' + distinctListOfQueries, 'application/json');
        });
    };

    FrontEndApi.submitWhatIf = function(arrayOfCommandsAndQueries) {
        var body = JSON.stringify({ sequence: arrayOfCommandsAndQueries });

        return decorateRequestWithTrackingAndSubmit("eCargo 'what if' command request submitted", "eCargo 'what if' command request completed", body, function() {
            return submitRequest(body, 'CommandsAndQueries/WhatIf', 'application/json');
        });
    };

    function submitSingleCommand(command) {
        return FrontEndApi.submit([command]);
    }

    function submitSingleQuery(query) {
        return FrontEndApi.submit([query])
            .then(function(response) {
                if(response) return response.json();
            })
            .then(function onResultsReceived(result) {
                if(result) return result[0];
            });
    }

    function submitCsvImport(commandName, blob) {
        return submitRequest(blob, 'Import/Csv/' + commandName, 'text/csv');
    }

    FrontEndApi.exportType = { Csv: 'Csv', Xml: 'Xml' };

    function submitExport(query, exportType) {
        var body = JSON.stringify({ sequence: [ query ] });
        return submitRequest(body, 'Export/' + exportType, 'application/json');
    }

    FrontEndApi.signInWithPassword = function(userName, password) {
        var body = JSON.stringify({ userName: userName, password: password });
        return submitRequest(body, 'SignIn/SetAuthenticationCookie', 'application/json');
    }

    FrontEndApi.premiumLogin = function(userName, password) {
        var body = JSON.stringify({ userName: userName, password: password });
        return submitRequest(body, 'SignIn/PremiumLogin', 'application/json');
    }

    FrontEndApi.getUserNameWithSessionKey = function(sessionKey) {
        var body = JSON.stringify({ sessionKey: sessionKey });
        return submitRequest(body, 'SignIn/GetUserNameFromPremiumSession', 'application/json');
    }

    FrontEndApi.sendAccountRecoveryEmail = function(userName) {
        var body = JSON.stringify({ value: userName });
        return submitRequest(body, 'Password/SendAccountRecoveryEmail', 'application/json');
    }

    FrontEndApi.resetPassword = function(userName, code, newPassword) {
        var body = JSON.stringify({ userName: { value: userName }, code: code, newPassword: newPassword });
        return submitRequest(body, 'Password/ResetPassword', 'application/json');
    }

    FrontEndApi.changePassword = function(existingPassword, newPassword) {
        var body = JSON.stringify({ existingPassword: existingPassword, newPassword: newPassword });
        return submitRequest(body, 'Password/ChangePassword', 'application/json');
    }

    FrontEndApi.AddShippingScheduleCommand = function(shippingSchedule) {
        this.name = 'AddShippingScheduleCommand';
        this.payload = { shippingSchedule: shippingSchedule };
    }

    FrontEndApi.addShippingSchedule = function (shippingSchedule) {
        return submitSingleCommand(new FrontEndApi.AddShippingScheduleCommand(shippingSchedule));
    }

    FrontEndApi.AddUserFeedbackCommand = function(feedback) {
        this.name = 'AddUserFeedbackCommand';
        this.payload = { feedback: feedback };
    }

    FrontEndApi.addUserFeedback = function (feedback) {
        return submitSingleCommand(new FrontEndApi.AddUserFeedbackCommand(feedback));
    }

    FrontEndApi.AddVesselForShippingLineCommand = function(vesselName, shippingLineId) {
        this.name = 'AddVesselForShippingLineCommand';
        this.payload = { vesselName: vesselName, shippingLineId: shippingLineId };
    }

    FrontEndApi.addVesselForShippingLine = function (vesselName, shippingLineId) {
        return submitSingleCommand(new FrontEndApi.AddVesselForShippingLineCommand(vesselName, shippingLineId));
    }

    FrontEndApi.AssignVehicleCommand = function(consignments, vehicle) {
        this.name = 'AssignVehicleCommand';
        this.payload = { consignments: consignments, vehicle: vehicle };
    }

    FrontEndApi.assignVehicle = function (consignments, vehicle) {
        return submitSingleCommand(new FrontEndApi.AssignVehicleCommand(consignments, vehicle));
    }

    FrontEndApi.CreateConsignmentsCommand = function(consignmentsToCreate) {
        this.name = 'CreateConsignmentsCommand';
        this.payload = { consignmentsToCreate: consignmentsToCreate };
    }

    FrontEndApi.createConsignments = function (consignmentsToCreate) {
        return submitSingleCommand(new FrontEndApi.CreateConsignmentsCommand(consignmentsToCreate));
    }

    FrontEndApi.CreateRateChargeTypeCommand = function(code, description, category, orderType, manualOnly, manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer) {
        this.name = 'CreateRateChargeTypeCommand';
        this.payload = { code: code, description: description, category: category, orderType: orderType, manualOnly: manualOnly, manualOnlyUnitOfMeasure: manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound: onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate: calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer: chargeSoldToPartyInsteadOfCustomer };
    }

    FrontEndApi.createRateChargeType = function (code, description, category, orderType, manualOnly, manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer) {
        return submitSingleCommand(new FrontEndApi.CreateRateChargeTypeCommand(code, description, category, orderType, manualOnly, manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer));
    }

    FrontEndApi.CreateUserFromUserTemplateCommand = function(data, userTemplate, businessToCreateThisUserUnder) {
        this.name = 'CreateUserFromUserTemplateCommand';
        this.payload = { data: data, userTemplate: userTemplate, businessToCreateThisUserUnder: businessToCreateThisUserUnder };
    }

    FrontEndApi.createUserFromUserTemplate = function (data, userTemplate, businessToCreateThisUserUnder) {
        return submitSingleCommand(new FrontEndApi.CreateUserFromUserTemplateCommand(data, userTemplate, businessToCreateThisUserUnder));
    }

    FrontEndApi.ConfirmConsignmentArrivalCommand = function(consignmentId, actualArrivalDate, actualDischargeDate, exceptionReason) {
        this.name = 'ConfirmConsignmentArrivalCommand';
        this.payload = { consignmentId: consignmentId, actualArrivalDate: actualArrivalDate, actualDischargeDate: actualDischargeDate, exceptionReason: exceptionReason };
    }

    FrontEndApi.confirmConsignmentArrival = function (consignmentId, actualArrivalDate, actualDischargeDate, exceptionReason) {
        return submitSingleCommand(new FrontEndApi.ConfirmConsignmentArrivalCommand(consignmentId, actualArrivalDate, actualDischargeDate, exceptionReason));
    }

    FrontEndApi.CopyUserCommand = function(data, basedOnUser) {
        this.name = 'CopyUserCommand';
        this.payload = { data: data, basedOnUser: basedOnUser };
    }

    FrontEndApi.copyUser = function (data, basedOnUser) {
        return submitSingleCommand(new FrontEndApi.CopyUserCommand(data, basedOnUser));
    }

    FrontEndApi.DeleteRateCardsCommand = function(rateCardIds) {
        this.name = 'DeleteRateCardsCommand';
        this.payload = { rateCardIds: rateCardIds };
    }

    FrontEndApi.deleteRateCards = function (rateCardIds) {
        return submitSingleCommand(new FrontEndApi.DeleteRateCardsCommand(rateCardIds));
    }

    FrontEndApi.DeleteShippingScheduleCommand = function(shippingScheduleId) {
        this.name = 'DeleteShippingScheduleCommand';
        this.payload = { shippingScheduleId: shippingScheduleId };
    }

    FrontEndApi.deleteShippingSchedule = function (shippingScheduleId) {
        return submitSingleCommand(new FrontEndApi.DeleteShippingScheduleCommand(shippingScheduleId));
    }

    FrontEndApi.DeliverConsignmentCommand = function(consignments, actualArrivalAt, actualDepartureAt, exceptionReason) {
        this.name = 'DeliverConsignmentCommand';
        this.payload = { consignments: consignments, actualArrivalAt: actualArrivalAt, actualDepartureAt: actualDepartureAt, exceptionReason: exceptionReason };
    }

    FrontEndApi.deliverConsignment = function (consignments, actualArrivalAt, actualDepartureAt, exceptionReason) {
        return submitSingleCommand(new FrontEndApi.DeliverConsignmentCommand(consignments, actualArrivalAt, actualDepartureAt, exceptionReason));
    }

    FrontEndApi.DispatchConsignmentCommand = function(consignments, departedAt) {
        this.name = 'DispatchConsignmentCommand';
        this.payload = { consignments: consignments, departedAt: departedAt };
    }

    FrontEndApi.dispatchConsignment = function (consignments, departedAt) {
        return submitSingleCommand(new FrontEndApi.DispatchConsignmentCommand(consignments, departedAt));
    }

    FrontEndApi.MergeConsignmentAndSaveDifferencesCommand = function(originalConsignment, updatedConsignment) {
        this.name = 'MergeConsignmentAndSaveDifferencesCommand';
        this.payload = { originalConsignment: originalConsignment, updatedConsignment: updatedConsignment };
    }

    FrontEndApi.mergeConsignmentAndSaveDifferences = function (originalConsignment, updatedConsignment) {
        return submitSingleCommand(new FrontEndApi.MergeConsignmentAndSaveDifferencesCommand(originalConsignment, updatedConsignment));
    }

    FrontEndApi.SendOutboundLoscamTransactionBatchFileCommand = function(fromActualPickupPointDepartureDateInclusive, toActualPickupPointDepartureDateInclusive, carriers, target) {
        this.name = 'SendOutboundLoscamTransactionBatchFileCommand';
        this.payload = { fromActualPickupPointDepartureDateInclusive: fromActualPickupPointDepartureDateInclusive, toActualPickupPointDepartureDateInclusive: toActualPickupPointDepartureDateInclusive, carriers: carriers, target: target };
    }

    FrontEndApi.sendOutboundLoscamTransactionBatchFile = function (fromActualPickupPointDepartureDateInclusive, toActualPickupPointDepartureDateInclusive, carriers, target) {
        return submitSingleCommand(new FrontEndApi.SendOutboundLoscamTransactionBatchFileCommand(fromActualPickupPointDepartureDateInclusive, toActualPickupPointDepartureDateInclusive, carriers, target));
    }

    FrontEndApi.SetConsignmentCommentsCommand = function(consignmentId, consignmentComments) {
        this.name = 'SetConsignmentCommentsCommand';
        this.payload = { consignmentId: consignmentId, consignmentComments: consignmentComments };
    }

    FrontEndApi.setConsignmentComments = function (consignmentId, consignmentComments) {
        return submitSingleCommand(new FrontEndApi.SetConsignmentCommentsCommand(consignmentId, consignmentComments));
    }

    FrontEndApi.SetConsignmentPickupDueAtCommand = function(consignmentId, dueAtDate, shouldSetTime, dueAtTime) {
        this.name = 'SetConsignmentPickupDueAtCommand';
        this.payload = { consignmentId: consignmentId, dueAtDate: dueAtDate, shouldSetTime: shouldSetTime, dueAtTime: dueAtTime };
    }

    FrontEndApi.setConsignmentPickupDueAt = function (consignmentId, dueAtDate, shouldSetTime, dueAtTime) {
        return submitSingleCommand(new FrontEndApi.SetConsignmentPickupDueAtCommand(consignmentId, dueAtDate, shouldSetTime, dueAtTime));
    }

    FrontEndApi.SetFeatureSwitchForUserCommand = function(user, featureSwitch, isEnabled) {
        this.name = 'SetFeatureSwitchForUserCommand';
        this.payload = { user: user, featureSwitch: featureSwitch, isEnabled: isEnabled };
    }

    FrontEndApi.setFeatureSwitchForUser = function (user, featureSwitch, isEnabled) {
        return submitSingleCommand(new FrontEndApi.SetFeatureSwitchForUserCommand(user, featureSwitch, isEnabled));
    }

    FrontEndApi.SetInvoiceExternalReferenceCommand = function(invoiceId, externalReference) {
        this.name = 'SetInvoiceExternalReferenceCommand';
        this.payload = { invoiceId: invoiceId, externalReference: externalReference };
    }

    FrontEndApi.setInvoiceExternalReference = function (invoiceId, externalReference) {
        return submitSingleCommand(new FrontEndApi.SetInvoiceExternalReferenceCommand(invoiceId, externalReference));
    }

    FrontEndApi.SetRateChargeTypeCommand = function(rateChargeType, description, orderType, manualOnly, manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer, businessesThatWillAutomaticallyCalculateThisCharge) {
        this.name = 'SetRateChargeTypeCommand';
        this.payload = { rateChargeType: rateChargeType, description: description, orderType: orderType, manualOnly: manualOnly, manualOnlyUnitOfMeasure: manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound: onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate: calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer: chargeSoldToPartyInsteadOfCustomer, businessesThatWillAutomaticallyCalculateThisCharge: businessesThatWillAutomaticallyCalculateThisCharge };
    }

    FrontEndApi.setRateChargeType = function (rateChargeType, description, orderType, manualOnly, manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer, businessesThatWillAutomaticallyCalculateThisCharge) {
        return submitSingleCommand(new FrontEndApi.SetRateChargeTypeCommand(rateChargeType, description, orderType, manualOnly, manualOnlyUnitOfMeasure, onlyAddChargeIfMatchingRateIsFound, calculateChargesUsingDeliveredDateInsteadOfDispatchDate, chargeSoldToPartyInsteadOfCustomer, businessesThatWillAutomaticallyCalculateThisCharge));
    }

    FrontEndApi.SetUserAuthorisationsForUserCommand = function(featuresTheUserShouldHaveAccessTo, user) {
        this.name = 'SetUserAuthorisationsForUserCommand';
        this.payload = { featuresTheUserShouldHaveAccessTo: featuresTheUserShouldHaveAccessTo, user: user };
    }

    FrontEndApi.setUserAuthorisationsForUser = function (featuresTheUserShouldHaveAccessTo, user) {
        return submitSingleCommand(new FrontEndApi.SetUserAuthorisationsForUserCommand(featuresTheUserShouldHaveAccessTo, user));
    }

    FrontEndApi.UpdateConsignmentItemCommand = function(consignmentId, consignmentItemId, quantities) {
        this.name = 'UpdateConsignmentItemCommand';
        this.payload = { consignmentId: consignmentId, consignmentItemId: consignmentItemId, quantities: quantities };
    }

    FrontEndApi.UpdateShippingScheduleCommand = function(shippingSchedule) {
        this.name = 'UpdateShippingScheduleCommand';
        this.payload = { shippingSchedule: shippingSchedule };
    }

    FrontEndApi.updateShippingSchedule = function (shippingSchedule) {
        return submitSingleCommand(new FrontEndApi.UpdateShippingScheduleCommand(shippingSchedule));
    }

    FrontEndApi.WithdrawConsignmentCommand = function(consignment, userComment) {
        this.name = 'WithdrawConsignmentCommand';
        this.payload = { consignment: consignment, userComment: userComment };
    }

    FrontEndApi.withdrawConsignment = function (consignment, userComment) {
        return submitSingleCommand(new FrontEndApi.WithdrawConsignmentCommand(consignment, userComment));
    }

    FrontEndApi.AllLogisticsProviderCustomerInvoicePartnersQuery = function() {
        this.name = 'AllLogisticsProviderCustomerInvoicePartnersQuery';
        this.payload = {};
    }

    FrontEndApi.getAllLogisticsProviderCustomerInvoicePartners = function () {
        return submitSingleQuery(new FrontEndApi.AllLogisticsProviderCustomerInvoicePartnersQuery());
    }

    FrontEndApi.AllLogisticsProviderSupplierInvoicePartnersQuery = function() {
        this.name = 'AllLogisticsProviderSupplierInvoicePartnersQuery';
        this.payload = {};
    }

    FrontEndApi.getAllLogisticsProviderSupplierInvoicePartners = function () {
        return submitSingleQuery(new FrontEndApi.AllLogisticsProviderSupplierInvoicePartnersQuery());
    }

    FrontEndApi.AllPortsQuery = function() {
        this.name = 'AllPortsQuery';
        this.payload = {};
    }

    FrontEndApi.getAllPorts = function () {
        return submitSingleQuery(new FrontEndApi.AllPortsQuery());
    }

    FrontEndApi.BusinessesByRelationshipQuery = function(relationshipTypesToRetrieve) {
        this.name = 'BusinessesByRelationshipQuery';
        this.payload = { relationshipTypesToRetrieve: relationshipTypesToRetrieve };
    }

    FrontEndApi.getBusinessesByRelationship = function (relationshipTypesToRetrieve) {
        return submitSingleQuery(new FrontEndApi.BusinessesByRelationshipQuery(relationshipTypesToRetrieve));
    }

    FrontEndApi.CarriersOnAccessibleConsignmentsQuery = function() {
        this.name = 'CarriersOnAccessibleConsignmentsQuery';
        this.payload = {};
    }

    FrontEndApi.getCarriersOnAccessibleConsignments = function () {
        return submitSingleQuery(new FrontEndApi.CarriersOnAccessibleConsignmentsQuery());
    }

    FrontEndApi.ConsignmentIdsByConsignmentNumberSearchCriterionQuery = function(consignmentNumberSearchCriterion, limit) {
        this.name = 'ConsignmentIdsByConsignmentNumberSearchCriterionQuery';
        this.payload = { consignmentNumberSearchCriterion: consignmentNumberSearchCriterion, limit: limit };
    }

    FrontEndApi.getConsignmentIdsByConsignmentNumberSearchCriterion = function (consignmentNumberSearchCriterion, limit) {
        return submitSingleQuery(new FrontEndApi.ConsignmentIdsByConsignmentNumberSearchCriterionQuery(consignmentNumberSearchCriterion, limit));
    }

    FrontEndApi.ConsignmentLabelsQuery = function(consignments, numberOfUncollatedCopies) {
        this.name = 'ConsignmentLabelsQuery';
        this.payload = { consignments: consignments, numberOfUncollatedCopies: numberOfUncollatedCopies };
    }

    FrontEndApi.getConsignmentLabels = function (consignments, numberOfUncollatedCopies) {
        return submitSingleQuery(new FrontEndApi.ConsignmentLabelsQuery(consignments, numberOfUncollatedCopies));
    }

    FrontEndApi.ConsignmentNotesAsSingleConcatenatedPdfQuery = function(consignments) {
        this.name = 'ConsignmentNotesAsSingleConcatenatedPdfQuery';
        this.payload = { consignments: consignments };
    }

    FrontEndApi.getConsignmentNotesAsSingleConcatenatedPdf = function (consignments) {
        return submitSingleQuery(new FrontEndApi.ConsignmentNotesAsSingleConcatenatedPdfQuery(consignments));
    }

    FrontEndApi.ConsignmentOwnerDefaultsQuery = function(consignmentOwner) {
        this.name = 'ConsignmentOwnerDefaultsQuery';
        this.payload = { consignmentOwner: consignmentOwner };
    }

    FrontEndApi.getConsignmentOwnerDefaults = function (consignmentOwner) {
        return submitSingleQuery(new FrontEndApi.ConsignmentOwnerDefaultsQuery(consignmentOwner));
    }

    FrontEndApi.CustomersOwnedByBusinessQuery = function(businessName) {
        this.name = 'CustomersOwnedByBusinessQuery';
        this.payload = { businessName: businessName };
    }

    FrontEndApi.getCustomersOwnedByBusiness = function (businessName) {
        return submitSingleQuery(new FrontEndApi.CustomersOwnedByBusinessQuery(businessName));
    }

    FrontEndApi.EstimatedDeliveryAtForConsignmentsQuery = function(consignments) {
        this.name = 'EstimatedDeliveryAtForConsignmentsQuery';
        this.payload = { consignments: consignments };
    }

    FrontEndApi.getEstimatedDeliveryAtForConsignments = function (consignments) {
        return submitSingleQuery(new FrontEndApi.EstimatedDeliveryAtForConsignmentsQuery(consignments));
    }

    FrontEndApi.ExistingRateCardCriteriaQuery = function() {
        this.name = 'ExistingRateCardCriteriaQuery';
        this.payload = {};
    }

    FrontEndApi.getExistingRateCardCriteria = function () {
        return submitSingleQuery(new FrontEndApi.ExistingRateCardCriteriaQuery());
    }

    FrontEndApi.InvoiceAddresseeOverrideRulesQuery = function() {
        this.name = 'InvoiceAddresseeOverrideRulesQuery';
        this.payload = {};
    }

    FrontEndApi.getInvoiceAddresseeOverrideRules = function () {
        return submitSingleQuery(new FrontEndApi.InvoiceAddresseeOverrideRulesQuery());
    }

    FrontEndApi.InvoiceIdsByCriteriaQuery = function(invoiceSide, invoiceNumberOrExternalReference, activity, invoiceTypes, invoiceStatuses, hasInvoiceLineWithMatchingLineStatus, supplierOrRecipientBusinesses, invoiceIssuedDateInterval) {
        this.name = 'InvoiceIdsByCriteriaQuery';
        this.payload = { invoiceSide: invoiceSide, invoiceNumberOrExternalReference: invoiceNumberOrExternalReference, activity: activity, invoiceTypes: invoiceTypes, invoiceStatuses: invoiceStatuses, hasInvoiceLineWithMatchingLineStatus: hasInvoiceLineWithMatchingLineStatus, supplierOrRecipientBusinesses: supplierOrRecipientBusinesses, invoiceIssuedDateInterval: invoiceIssuedDateInterval };
    }

    FrontEndApi.getInvoiceIdsByCriteria = function (invoiceSide, invoiceNumberOrExternalReference, activity, invoiceTypes, invoiceStatuses, hasInvoiceLineWithMatchingLineStatus, supplierOrRecipientBusinesses, invoiceIssuedDateInterval) {
        return submitSingleQuery(new FrontEndApi.InvoiceIdsByCriteriaQuery(invoiceSide, invoiceNumberOrExternalReference, activity, invoiceTypes, invoiceStatuses, hasInvoiceLineWithMatchingLineStatus, supplierOrRecipientBusinesses, invoiceIssuedDateInterval));
    }

    FrontEndApi.InvoiceStatusSummariesByActivityQuery = function(activity, invoiceSide) {
        this.name = 'InvoiceStatusSummariesByActivityQuery';
        this.payload = { activity: activity, invoiceSide: invoiceSide };
    }

    FrontEndApi.getInvoiceStatusSummariesByActivity = function (activity, invoiceSide) {
        return submitSingleQuery(new FrontEndApi.InvoiceStatusSummariesByActivityQuery(activity, invoiceSide));
    }

    FrontEndApi.LastShippingScheduleIdQuery = function() {
        this.name = 'LastShippingScheduleIdQuery';
        this.payload = {};
    }

    FrontEndApi.getLastShippingScheduleId = function () {
        return submitSingleQuery(new FrontEndApi.LastShippingScheduleIdQuery());
    }

    FrontEndApi.LeadTimesByOwnerAndCustomerQuery = function(customerId) {
        this.name = 'LeadTimesByOwnerAndCustomerQuery';
        this.payload = { customerId: customerId };
    }

    FrontEndApi.getLeadTimesByOwnerAndCustomer = function (customerId) {
        return submitSingleQuery(new FrontEndApi.LeadTimesByOwnerAndCustomerQuery(customerId));
    }

    FrontEndApi.MenuStructureByUserQuery = function() {
        this.name = 'MenuStructureByUserQuery';
        this.payload = {};
    }

    FrontEndApi.getMenuStructureByUser = function () {
        return submitSingleQuery(new FrontEndApi.MenuStructureByUserQuery());
    }

    FrontEndApi.PickupAndDeliveryPointsAdminSecurityQuery = function(pickupDeliveryResourceId) {
        this.name = 'PickupAndDeliveryPointsAdminSecurityQuery';
        this.payload = { pickupDeliveryResourceId: pickupDeliveryResourceId };
    }

    FrontEndApi.getPickupAndDeliveryPointsAdminSecurity = function (pickupDeliveryResourceId) {
        return submitSingleQuery(new FrontEndApi.PickupAndDeliveryPointsAdminSecurityQuery(pickupDeliveryResourceId));
    }

    FrontEndApi.PlannedConsignmentArrivalsQuery = function() {
        this.name = 'PlannedConsignmentArrivalsQuery';
        this.payload = {};
    }

    FrontEndApi.getPlannedConsignmentArrivals = function () {
        return submitSingleQuery(new FrontEndApi.PlannedConsignmentArrivalsQuery());
    }

    FrontEndApi.RateActivityLookupsQuery = function() {
        this.name = 'RateActivityLookupsQuery';
        this.payload = {};
    }

    FrontEndApi.getRateActivityLookups = function () {
        return submitSingleQuery(new FrontEndApi.RateActivityLookupsQuery());
    }

    FrontEndApi.RateCardActionAuditLogEntriesQuery = function(actionCompletedWithin, maximumNumberOfResults) {
        this.name = 'RateCardActionAuditLogEntriesQuery';
        this.payload = { actionCompletedWithin: actionCompletedWithin, maximumNumberOfResults: maximumNumberOfResults };
    }

    FrontEndApi.getRateCardActionAuditLogEntries = function (actionCompletedWithin, maximumNumberOfResults) {
        return submitSingleQuery(new FrontEndApi.RateCardActionAuditLogEntriesQuery(actionCompletedWithin, maximumNumberOfResults));
    }

    FrontEndApi.RateChargeTypeDetailsQuery = function() {
        this.name = 'RateChargeTypeDetailsQuery';
        this.payload = {};
    }

    FrontEndApi.getRateChargeTypeDetails = function () {
        return submitSingleQuery(new FrontEndApi.RateChargeTypeDetailsQuery());
    }

    FrontEndApi.ReportsAccessibleByUserQuery = function(user) {
        this.name = 'ReportsAccessibleByUserQuery';
        this.payload = { user: user };
    }

    FrontEndApi.getReportsAccessibleByUser = function (user) {
        return submitSingleQuery(new FrontEndApi.ReportsAccessibleByUserQuery(user));
    }

    FrontEndApi.ReportsAvailableToUserQuery = function(user) {
        this.name = 'ReportsAvailableToUserQuery';
        this.payload = { user: user };
    }

    FrontEndApi.getReportsAvailableToUser = function (user) {
        return submitSingleQuery(new FrontEndApi.ReportsAvailableToUserQuery(user));
    }

    FrontEndApi.ShippingLineLookupsByUserQuery = function() {
        this.name = 'ShippingLineLookupsByUserQuery';
        this.payload = {};
    }

    FrontEndApi.getShippingLineLookupsByUser = function () {
        return submitSingleQuery(new FrontEndApi.ShippingLineLookupsByUserQuery());
    }

    FrontEndApi.ShippingScheduleByIdQuery = function(shippingScheduleId) {
        this.name = 'ShippingScheduleByIdQuery';
        this.payload = { shippingScheduleId: shippingScheduleId };
    }

    FrontEndApi.getShippingScheduleById = function (shippingScheduleId) {
        return submitSingleQuery(new FrontEndApi.ShippingScheduleByIdQuery(shippingScheduleId));
    }

    FrontEndApi.ShippingScheduleSummariesQuery = function(shippingLineId, vesselId, voyageNumber, firstPortDepartsOnOrAfter, anyPortHasArrivalDateOnOrAfter, maximumRowsReturned) {
        this.name = 'ShippingScheduleSummariesQuery';
        this.payload = { shippingLineId: shippingLineId, vesselId: vesselId, voyageNumber: voyageNumber, firstPortDepartsOnOrAfter: firstPortDepartsOnOrAfter, anyPortHasArrivalDateOnOrAfter: anyPortHasArrivalDateOnOrAfter, maximumRowsReturned: maximumRowsReturned };
    }

    FrontEndApi.getShippingScheduleSummaries = function (shippingLineId, vesselId, voyageNumber, firstPortDepartsOnOrAfter, anyPortHasArrivalDateOnOrAfter, maximumRowsReturned) {
        return submitSingleQuery(new FrontEndApi.ShippingScheduleSummariesQuery(shippingLineId, vesselId, voyageNumber, firstPortDepartsOnOrAfter, anyPortHasArrivalDateOnOrAfter, maximumRowsReturned));
    }

    FrontEndApi.ShouldCustomerBeEditableByLogisticsProviderQuery = function(customerBusinessId) {
        this.name = 'ShouldCustomerBeEditableByLogisticsProviderQuery';
        this.payload = { customerBusinessId: customerBusinessId };
    }

    FrontEndApi.getShouldCustomerBeEditableByLogisticsProvider = function (customerBusinessId) {
        return submitSingleQuery(new FrontEndApi.ShouldCustomerBeEditableByLogisticsProviderQuery(customerBusinessId));
    }

    FrontEndApi.UnitsOfMeasureQuery = function(option) {
        this.name = 'UnitsOfMeasureQuery';
        this.payload = { option: option };
    }

    FrontEndApi.getUnitsOfMeasure = function (option) {
        return submitSingleQuery(new FrontEndApi.UnitsOfMeasureQuery(option));
    }

    FrontEndApi.UserAuthorisationByUserIdQuery = function(userId) {
        this.name = 'UserAuthorisationByUserIdQuery';
        this.payload = { userId: userId };
    }

    FrontEndApi.getUserAuthorisationByUserId = function (userId) {
        return submitSingleQuery(new FrontEndApi.UserAuthorisationByUserIdQuery(userId));
    }

    FrontEndApi.UserAuthorisationHierarchyQuery = function() {
        this.name = 'UserAuthorisationHierarchyQuery';
        this.payload = {};
    }

    FrontEndApi.getUserAuthorisationHierarchy = function () {
        return submitSingleQuery(new FrontEndApi.UserAuthorisationHierarchyQuery());
    }

    FrontEndApi.ViewableRateCardsByCriteriaQuery = function(rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval) {
        this.name = 'ViewableRateCardsByCriteriaQuery';
        this.payload = { rateCardOwners: rateCardOwners, rateActivities: rateActivities, rateChargeTypes: rateChargeTypes, rateCardTypes: rateCardTypes, customers: customers, suppliers: suppliers, soldToParties: soldToParties, rateProducts: rateProducts, fromRateZones: fromRateZones, toRateZones: toRateZones, effectiveDateInterval: effectiveDateInterval };
    }

    FrontEndApi.getViewableRateCardsByCriteria = function (rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval) {
        return submitSingleQuery(new FrontEndApi.ViewableRateCardsByCriteriaQuery(rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval));
    }

    FrontEndApi.ViewableRateCardsByIdsQuery = function(rateCardIds) {
        this.name = 'ViewableRateCardsByIdsQuery';
        this.payload = { rateCardIds: rateCardIds };
    }

    FrontEndApi.getViewableRateCardsByIds = function (rateCardIds) {
        return submitSingleQuery(new FrontEndApi.ViewableRateCardsByIdsQuery(rateCardIds));
    }

    FrontEndApi.WebApplicationProfileQuery = function() {
        this.name = 'WebApplicationProfileQuery';
        this.payload = {};
    }

    FrontEndApi.getWebApplicationProfile = function () {
        return submitSingleQuery(new FrontEndApi.WebApplicationProfileQuery());
    }

    FrontEndApi.ImportConsignmentsFromCsvCommand = function(rawCsvLines) {
        this.name = 'ImportConsignmentsFromCsvCommand';
        this.payload = { rawCsvLines: rawCsvLines };
    }

    FrontEndApi.importConsignmentsFromCsv = function (rawCsvLines) {
        var query = new FrontEndApi.ImportConsignmentsFromCsvCommand(rawCsvLines);
        return submitCsvImport(query.name, query.payload.rawCsvLines);
    }

    FrontEndApi.ImportRatesFromCsvCommand = function(rawCsvLines) {
        this.name = 'ImportRatesFromCsvCommand';
        this.payload = { rawCsvLines: rawCsvLines };
    }

    FrontEndApi.importRatesFromCsv = function (rawCsvLines) {
        var query = new FrontEndApi.ImportRatesFromCsvCommand(rawCsvLines);
        return submitCsvImport(query.name, query.payload.rawCsvLines);
    }

    FrontEndApi.CsvImportTemplateQuery = function() {
        this.name = 'CsvImportTemplateQuery';
        this.payload = {};
    }

    FrontEndApi.getCsvImportTemplate = function (exportType) {
        var query = new FrontEndApi.CsvImportTemplateQuery();
        return submitExport(query, exportType);
    }

    FrontEndApi.ExportRateCardsAsCsvQuery = function(rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval) {
        this.name = 'ExportRateCardsAsCsvQuery';
        this.payload = { rateCardOwners: rateCardOwners, rateActivities: rateActivities, rateChargeTypes: rateChargeTypes, rateCardTypes: rateCardTypes, customers: customers, suppliers: suppliers, soldToParties: soldToParties, rateProducts: rateProducts, fromRateZones: fromRateZones, toRateZones: toRateZones, effectiveDateInterval: effectiveDateInterval };
    }

    FrontEndApi.getExportRateCardsAsCsv = function (rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval, exportType) {
        var query = new FrontEndApi.ExportRateCardsAsCsvQuery(rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval);
        return submitExport(query, exportType);
    }

    FrontEndApi.RateCardActionAuditFileContentQuery = function(rateCardActionAuditId) {
        this.name = 'RateCardActionAuditFileContentQuery';
        this.payload = { rateCardActionAuditId: rateCardActionAuditId };
    }

    FrontEndApi.getRateCardActionAuditFileContent = function (rateCardActionAuditId, exportType) {
        var query = new FrontEndApi.RateCardActionAuditFileContentQuery(rateCardActionAuditId);
        return submitExport(query, exportType);
    }

    FrontEndApi.RateCardActionAuditReportQuery = function(rateCardActionAuditIds) {
        this.name = 'RateCardActionAuditReportQuery';
        this.payload = { rateCardActionAuditIds: rateCardActionAuditIds };
    }

    FrontEndApi.getRateCardActionAuditReport = function (rateCardActionAuditIds, exportType) {
        var query = new FrontEndApi.RateCardActionAuditReportQuery(rateCardActionAuditIds);
        return submitExport(query, exportType);
    }

    FrontEndApi.SetConsignmentNumberCommand = function(consignment, consignmentNumber) {
        this.name = 'SetConsignmentNumberCommand';
        this.payload = { consignment: consignment, consignmentNumber: consignmentNumber };
    }

    FrontEndApi.SetConsignmentDeliveryPlannedDateCommand = function(consignment, dateTimeToSet, plannedDate) {
        this.name = 'SetConsignmentDeliveryPlannedDateCommand';
        this.payload = { consignment: consignment, dateTimeToSet: dateTimeToSet, plannedDate: plannedDate };
    }

    FrontEndApi.SetConsignmentDeliveryPlannedTimeCommand = function(consignment, dateTimeToSet, plannedTime) {
        this.name = 'SetConsignmentDeliveryPlannedTimeCommand';
        this.payload = { consignment: consignment, dateTimeToSet: dateTimeToSet, plannedTime: plannedTime };
    }

    FrontEndApi.SetConsignmentPickupPlannedDateCommand = function(consignment, dateTimeToSet, plannedDate) {
        this.name = 'SetConsignmentPickupPlannedDateCommand';
        this.payload = { consignment: consignment, dateTimeToSet: dateTimeToSet, plannedDate: plannedDate };
    }

    FrontEndApi.SetConsignmentPickupPlannedTimeCommand = function(consignment, dateTimeToSet, plannedTime) {
        this.name = 'SetConsignmentPickupPlannedTimeCommand';
        this.payload = { consignment: consignment, dateTimeToSet: dateTimeToSet, plannedTime: plannedTime };
    }

    FrontEndApi.SetConsignmentProtectionTypeCommand = function(consignment, protectionType) {
        this.name = 'SetConsignmentProtectionTypeCommand';
        this.payload = { consignment: consignment, protectionType: protectionType };
    }

    FrontEndApi.SetConsignmentPurchaseOrderNumberCommand = function(consignment, purchaseOrderNumber) {
        this.name = 'SetConsignmentPurchaseOrderNumberCommand';
        this.payload = { consignment: consignment, purchaseOrderNumber: purchaseOrderNumber };
    }

    FrontEndApi.SetConsignmentBookingReferenceCommand = function(consignment, bookingReference) {
        this.name = 'SetConsignmentBookingReferenceCommand';
        this.payload = { consignment: consignment, bookingReference: bookingReference };
    }

    FrontEndApi.SetConsignmentTransportationModeCommand = function(consignment, newTransportationMode, shouldAddHistoryEntry) {
        this.name = 'SetConsignmentTransportationModeCommand';
        this.payload = { consignment: consignment, newTransportationMode: newTransportationMode, shouldAddHistoryEntry: shouldAddHistoryEntry };
    }

    FrontEndApi.SetConsignmentWaypointBusinessAndAddressCommand = function(consignment, waypointType, business, address) {
        this.name = 'SetConsignmentWaypointBusinessAndAddressCommand';
        this.payload = { consignment: consignment, waypointType: waypointType, business: business, address: address };
    }

    FrontEndApi.UpdateConsignmentItemCommand = function(consignmentId, consignmentItemId, quantities) {
        this.name = 'UpdateConsignmentItemCommand';
        this.payload = { consignmentId: consignmentId, consignmentItemId: consignmentItemId, quantities: quantities };
    }

    return FrontEndApi;
}

)();

const baseSubmit = FrontEndApi.submit;

FrontEndApi.submit = async function(arrayOfCommandsAndQueries) {
    try {
        const response = await baseSubmit(arrayOfCommandsAndQueries);
        return response;
    } catch (e) {
        console.error(e);
        throw(e instanceof Error ? e : new Error(e));
    }
}

FrontEndApi.getCommandAuthorisations = async function(commandsThatMayBeExecuted) {
    const toPascalCase = (commandName) => commandName.charAt(0).toUpperCase() + commandName.slice(1);
    const toApiCommandName = (commandName) => toPascalCase(commandName) + 'Command'; // e.g. deleteRateCards => DeleteRateCardsCommand

    const convertToCommandAuthorisationRequests = (requestedPermissionsWithParameters) =>
        Object.keys(requestedPermissionsWithParameters).map(perm => {
            const apiCommandRequest = {
                commandName: perm,
                parameters:  requestedPermissionsWithParameters[perm]
            };
            return apiCommandRequest;
        });

    const toCommandAuthorisations = (commandNameParameterPairs, whatIfApiResponse) => {
        const toAuthorisationName = (commandName) => 'can' + toPascalCase(commandName); // e.g. deleteRateCards => canDeleteRateCards

        let commandAuthorisationsGranted = {};
        commandNameParameterPairs.forEach((cnp, index) => {
            commandAuthorisationsGranted[toAuthorisationName(cnp.commandName)] = whatIfApiResponse[index];
        });
        return commandAuthorisationsGranted;
    }

    const commandNameParameterPairs = convertToCommandAuthorisationRequests(commandsThatMayBeExecuted);

    const commandsOrQueries = commandNameParameterPairs.map(cnp =>
        new FrontEndApi[toApiCommandName(cnp.commandName)](...cnp.parameters));

    const response = await FrontEndApi.submitWhatIf(commandsOrQueries);
    const commandAuthorisationsGranted = toCommandAuthorisations(commandNameParameterPairs, await response.json());

    return commandAuthorisationsGranted;
}

export default FrontEndApi;

/* Sample code:
FrontEndApi.submit([new FrontEndApi.LeadTimesByOwnerAndCustomerQuery()])
    .then(
        function() { alert('Success!'); },
        function() { alert('FAIL!'); }
    )

OR

await FrontEndApi.getLeadTimesByOwnerAndCustomer();
alert('Success!');
*/
